import { fillableElements, FormRestructureEvent } from "../core";

/**
* @param {EventTarget?} obj
*/
function onControlInteracted(obj) {
  if (!obj || !(obj instanceof HTMLElement) || !obj.matches(fillableElements)) return;
  const target = /** @type {HTMLElement & { value: string }} */ (obj);
  const value = target.value ?? "";
	
  const hasValue = value.trim() !== "";

	if (hasValue && target.dataset.edited !== "true") {
		target.dataset.edited = "true";
	}
}

/**
 * @param {HTMLFormElement} form 
 */
export function addEdited(form) {
  form.addEventListener("restructure", event => {
		if (!(event instanceof FormRestructureEvent)) return;

    const eventTypes = ['input', 'change', 'blur'];
    for (const entry of event.added) {
			for (const node of entry.elements) {
				eventTypes.forEach(ev => {
					node.addEventListener(ev, e => onControlInteracted(e.target));
				});

				const value = node.value ?? "";

				if (!node.dataset.edited && value.trim()) {
					node.dataset.edited = "true";
				}
			}
		}
  });
}
